import {
  TrQuals, TrQualXQualTasks, TrQualTasks, TrQualXAssigned, TrQualXJobAssignments,
  TrQualXJobTitles, TrQualTaskXPrerequisites, TrTrainers, TrQualTaskXTrainers, TrQtNotRequired, TrQualNotRequired, TrQtHistory, TrQualHistory
} from "../../../../models";


export class Quals extends TrQuals {
  constructor() {
    super();
    this.qualId = 0;
    this.qualDesc = null;
    this.requiredByAllEmps = false;
    this.active = true;
    this.qualOwnerId = null;
  }

}

export class QualXQualTasks extends TrQualXQualTasks {
  constructor() {
    super();
    this.qualQualTaskId = 0;
    this.qualId = null;
    this.qualTaskId = null;
  }

}

export class QualTasks extends TrQualTasks {
  constructor() {
    super();
    this.qualTaskId = 0;
    this.qtDesc = null;
    this.intervalInMonths = 0;
    this.qualTaskUrlLink = null;
    this.qualTaskWsOwnerId = null;
    this.hazwoper = false;
    this.active = true;
  }
}

export class QualXAssigned extends TrQualXAssigned {
  constructor() {
    super();
    this.qualAssignedId = 0;
    this.qualId = null;
    this.employeeId = null;
  }

}

export class QualXJobAssignments extends TrQualXJobAssignments {
  constructor() {
    super();
    this.qualJobAssignmentId = 0;
    this.qualId = null;
    this.employeeJobAssignmentId = null;
  }

}

export class QualXJobTitles extends TrQualXJobTitles {
  constructor() {
    super();
    this.qualJobTitleId = 0;
    this.qualId = null;
    this.jobTitleId = null;
  }

}

export class QualTaskXPrerequisites extends TrQualTaskXPrerequisites {
  constructor() {
    super();
    this.qualTaskPreReqId = 0;
    this.qualTaskId = null;
    this.preReqQualTaskId = null;
  }

}

export class Trainers extends TrTrainers {
  constructor() {
    super();
    this.trainerId = 0;
    this.employeeId = null;
    this.active = true;
  }
}

export class QualTaskXTrainers extends TrQualTaskXTrainers {
  constructor() {
    super();
    this.qualTaskTrainerId = 0;
    this.qualTaskId = null;
    this.trainerId = null;
  }

}

export class QtNotRequired  extends TrQtNotRequired {
  constructor() {
    super();
    this.qtNotRequiredId = 0;
    this.qualTaskId = null;
    this.employeeId = null;
  }

}

export class QualNotRequired extends TrQualNotRequired {
  constructor() {
    super();
    this.qualNotRequiredId = 0;
    this.qualId = null;
    this.employeeId = null;

  }
}

export class QtHistory extends TrQtHistory {
  constructor() {
    super();
    this.qtHistoryId = 0;
    this.qualTaskId = null;
    this.employeeId = null;
    this.completedOn = null;
    this.trainedById = null;
    this.certifiedById = null;
    this.revokedOn = null;
    this.revokedById = null;
    this.revokedReason = null;
    this.revoked = false;
  }

}
export class QualHistory extends TrQualHistory {
  constructor() {
    super();
    this.qualHistoryId = 0;
    this.qualId = null;
    this.employeeId = null;
    this.approvedOn = null;
    this.approvedById = null;
    this.revokedOn = null;
    this.revokedById = null;
  }

}
